import { useErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router-dom";
import { TitlesTyp } from "../Typography/Typography";
import { Button } from "../core/Button/Button";
import { StyledPageContainer } from "./ErrorBoundaryFallback.styled";

const ErrorBoundaryFallback = () => {
  const navigate = useNavigate();
  const { resetBoundary } = useErrorBoundary();

  const handleReload = () => {
    navigate("/");
    resetBoundary();
  };

  return (
    <StyledPageContainer>
      <TitlesTyp>Something went wrong :(</TitlesTyp>
      <Button onClick={handleReload} label={"Try again"} />
    </StyledPageContainer>
  );
};

export default ErrorBoundaryFallback;
